<h3 class="text-h3-l">Модалка</h3>
<button sdButton (click)="onOpenModal()">Открыть модалку</button>

<h3 class="text-h3-l">Bottom sheet (мвс)</h3>
<p>с блокированным оверлеем, брейкпоинты 20%-50%-90%</p>
<button sdButton (click)="onOpenBottomSheet()">Bottom sheet</button>

<h3 class="text-h3-l">Bottom sheet2 (мвс)</h3>
<p>не с блокированным оверлеем , брейкпоинты 30-70</p>
<button sdButton (click)="onOpenBottomSheet2()">Bottom sheet</button>
<h3 class="text-h3-l">Bottom sheet3 (мвс)</h3>
<button sdButton (click)="onOpenBottomSheet3()">Bottom sheet3</button>

<h3 class="text-h3-l">Ссылки темами</h3>
<div>
  <a class="link-orange">Link1</a>
  <a class="link-hover-orange">Link2</a>
  <a class="link-underlined">Link3</a>
  <a class="link-hover-underlined">Link4</a>
  <a class="link-black link-underlined link-hover-underlined">Link5</a>
</div>

<h3 class="text-h3-l">Кнопочки</h3>
<div>
  <button sdButton [theme]="'primary'">Primary</button>
  <button sdButton [theme]="'secondary'">secondary</button>
  <button sdButton [theme]="'outlined'">outlined</button>
  <button sdButton [theme]="'link'">link</button>
  <button sdButton [theme]="'primary'" [loading]="true">Primary</button>
  <button sdButton [theme]="'secondary'" [loading]="true">secondary</button>

  <button sdButton size="s">Small</button>
  <button sdButton size="m">Medium</button>
  <button sdButton size="l">Large</button>
</div>

<h3 class="text-h3-l">Типография</h3>

<div class="text-h2-l text-md-h5-s">Text h2/L for mobile, h5/S for other</div>
<div class="text-with-extend">Text with extend h2/L for mobile, h5/S for other</div>

<h3 class="text-h3-l">Иконки</h3>

@for (icon of iconTypes; track $index) {
  <div class="d-flex gap-3 align-items-center">
    <div class="text-b2-s-500">{{ icon }}</div>
    @for (size of iconSizes; track $index) {
      <span class="icon-border">
        <sd-icon [type]="icon" class="icon-size-{{ size }} color-orange"></sd-icon>
      </span>
    }
  </div>
}

<h3 class="text-h3-l">Текстовое поле</h3>

<div class="d-flex flex-wrap gap-5">
  <sd-input label="Label" comment="comment">
    <input type="tel" class="form-control" autofocus />
  </sd-input>
  <sd-input label="Label">
    <input type="tel" class="form-control" placeholder="Placeholder" />
  </sd-input>
  <sd-input label="Label">
    <input type="tel" class="form-control" placeholder="Placeholder" />
  </sd-input>

  <sd-input label="Label" comment="comment" error="error message">
    <input type="tel" class="form-control" placeholder="Placeholder" />
  </sd-input>
</div>
